import {
    establishementKey,
    contactsStorageKey,
    dossierStorageKey,
    settingStorageKey,
} from "../../consts";
import { EstablishmentCategory } from "../ClientSpace";
import { ContactProfil } from "../Contact";

export type AuthUser = {
    id: number | null;
    firstName: string;
    lastName: string;
    roleId?: number | null;
    establishment: number | null;
    phoneNumber: string;
    email: string;
    groups: number[];
    network?: number;
    region?: number | null;
    establishmentGroup?: number | null;
};

export type AuthContextType = {
    user: AuthUser;
    access: string;
    refresh: string;
    login: Function;
    logout: Function;
    adminUser?: AuthUser;
    currentUserRoleId  : RolesEnum 
};

export type UserLoginData = {
    email: string;
    password: string;
};

export interface AuthType {
    user: AuthUser;
    access: string;
    refresh: string;    
    userAdmin?: AuthUser;
    currentUserRoleId  : RolesEnum 
}

export interface Session {
    auth: AuthType;
    [establishementKey]: {
        establishmentTypes: EstablishmentCategory[];
        establishmentGroups: EstablishmentCategory[];
    };
    [contactsStorageKey]: {
        profils: ContactProfil[];
    };
    [dossierStorageKey]: {
        dossierStatus: { id: number; label: string; code: string }[];
        establishmentStatus: { id: number; label: string; code: string }[];
    };
    [settingStorageKey]: {
        key: string;
        value: string;
    }[];
}

export type ChangePasswordInfos = {
    email: string;
    password: string;
    new_password: string;
};

export enum RolesEnum {
    DEFAULT = -1,
    CLIENT = 1,
    SYNERPA = 2,
    INSTRUCTEUR = 3,
    ADMIN = 4,
    ADMIN_RESEAU = 5,
    ADMIN_REGION = 6,
}

export const RoleNamesEnum  :{ [key: number]: string }  = {
    [RolesEnum.CLIENT] : 'CLIENT',
    [RolesEnum.SYNERPA] : 'SYNERPA',
    [RolesEnum.INSTRUCTEUR] : 'INSTRUCTEUR',
    [RolesEnum.ADMIN] : 'ADMIN',
    [RolesEnum.ADMIN_RESEAU] : 'ADMIN_RESEAU',
    [RolesEnum.ADMIN_REGION] : 'ADMIN_REGION'
}